import { State } from '../state';

export const ResetUserSuggestionSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    resetUserSuggestion: (state: State) => state.ResetUserSuggestion,
};
